import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ScheduleFragment = { frequency: Types.CronFrequencyEnum, timezone: string, time: string, dayOfWeek?: Types.DayOfWeekEnum | null, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, MonthOfYear?: Types.MonthOfYearEnum | null, startDate?: string | null, custom?: { frequency: Types.CustomFrequencyEnum, interval: number, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, monthOfYear?: Types.MonthOfYearEnum | null } | null, endScheduleInfo?: { endScheduleType: Types.EndScheduleTypeEnum, date?: string | null, numberOfOccurrences?: number | null } | null };


export type ScheduleFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ScheduleFragmentDoc = /*#__PURE__*/ gql`
    fragment Schedule on ScheduleInfo {
  frequency
  timezone
  time
  dayOfWeek
  daysOfWeek
  weekOfMonth
  weeksOfMonth
  dayOfMonth
  MonthOfYear
  startDate
  custom {
    frequency
    interval
    daysOfWeek
    weekOfMonth
    weeksOfMonth
    dayOfMonth
    monthOfYear
  }
  endScheduleInfo {
    endScheduleType
    date
    numberOfOccurrences
  }
}
    `;